<template>
  <PapeleriaRequestsForm :typeEndPoint="'papeleriaRequestsShow'" :dataParams="this.$route.params" />
</template>
<script>
import PapeleriaRequestsForm from '@/components/modules/papeleria/requests/form'
export default {
  name: 'PapeleriaRequestsEdit',
  components: {
    PapeleriaRequestsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/requests/edit.vue